import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
import './Alert.less';
import AlertIcon from './AlertIcon';
import { AlertHighIcon, AlertMediumIcon } from '../../assets/svgs';
import SuccessIcon from './SuccessIcon';
import { NonDismissibleAlert } from './NonDismissibleAlert';
import { DismissibleAlert } from './DismissibleAlert';
const ALERT_TYPES_ICONS = {
    success: React.createElement(SuccessIcon, null),
    warning: React.createElement(AlertHighIcon, null),
    advisory: React.createElement(AlertMediumIcon, null),
    info: React.createElement(AlertIcon, null),
};
function getActualIcon(icon, alertType) {
    if (icon)
        return icon;
    return ALERT_TYPES_ICONS[alertType] || React.createElement(AlertIcon, null);
}
export function BaseAlert(props) {
    const { alertType = 'info', inline = false, noTopSpacer = false, className, icon, dismissibleOptions } = props, otherProps = __rest(props, ["alertType", "inline", "noTopSpacer", "className", "icon", "dismissibleOptions"]);
    const classNames = clsx('kal-alert', `kal-alert--${alertType}`, inline && `kal-alert--inline`, noTopSpacer && `kal-no-top-spacer`, className);
    return dismissibleOptions ? (React.createElement(DismissibleAlert, Object.assign({ className: classNames, icon: getActualIcon(icon, alertType), noTopSpacer: noTopSpacer, isOpen: dismissibleOptions === null || dismissibleOptions === void 0 ? void 0 : dismissibleOptions.isOpen, dismissButtonText: dismissibleOptions === null || dismissibleOptions === void 0 ? void 0 : dismissibleOptions.dismissButtonText, onDismiss: dismissibleOptions === null || dismissibleOptions === void 0 ? void 0 : dismissibleOptions.onDismiss }, otherProps))) : (React.createElement(NonDismissibleAlert, Object.assign({ className: classNames, icon: getActualIcon(icon, alertType) }, otherProps)));
}
export const AlertInfo = (props) => React.createElement(BaseAlert, Object.assign({ alertType: 'info' }, props));
export const AlertWarning = (props) => React.createElement(BaseAlert, Object.assign({ alertType: 'warning' }, props));
export const AlertSuccess = (props) => React.createElement(BaseAlert, Object.assign({ alertType: 'success' }, props));
export const AlertAdvisory = (props) => React.createElement(BaseAlert, Object.assign({ alertType: 'advisory' }, props));
//# sourceMappingURL=Alert.js.map